import { FileInput, FileInputProps, Group, Center } from "@mantine/core";
import { IconPhoto } from "@tabler/icons";
import { File } from "tabler-icons-react";

function Value({ file }) {
  return (
    <Center
      inline
      sx={(theme) => ({
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.dark[7]
            : theme.colors.gray[1],
        fontSize: theme.fontSizes.xs,
        padding: "3px 7px",
        borderRadius: theme.radius.sm,
      })}
    >
      <File size={14} style={{ marginRight: 5 }} />
      <span
        style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          maxWidth: 200,
          display: "inline-block",
        }}
      >
        {file.name}
      </span>
    </Center>
  );
}

const ValueComponent = ({ value }) => {
  if (Array.isArray(value)) {
    return (
      <Group spacing="sm" py="xs">
        {value.map((file, index) => (
          <Value file={file} key={index} />
        ))}
      </Group>
    );
  }

  return <Value file={value} />;
};

export const DropzoneComponent = ({ form, validateName }) => {
  return (
    <FileInput
      placeholder="Job Attachments"
      multiple
      valueComponent={ValueComponent}
      {...form.getInputProps(validateName)}
      clearable={false}
    />
  );
};
